import React from 'react';
import { LayerGroup, WMSTileLayer, LayersControl } from 'react-leaflet';
import RasterDataLegend from '../legends/RasterDataLegend.jsx';

const { Overlay, } = LayersControl
const GEOSERVER_TERRAIN_LAYER_NAME = 'terrain'
const AVAILABLE = true

export class TerrainLayers {

    static getMapLayers(t) {
        const name = t("map.terrain") + (AVAILABLE ? "" : " (Unavailable)");

        return (
            <Overlay name={name} dataType={t("map.terrain")}>
                <LayerGroup id="terrainLayer" >
                    <WMSTileLayer
                        url='/maps/geodata/wms'
                        layers={GEOSERVER_TERRAIN_LAYER_NAME}
                        format='image/png'
                        transparent='true'
                        opacity="0.7"
                    />
                </LayerGroup>
            </Overlay>
        )
    }

    static getLegend(t) {
        return <RasterDataLegend
            layerName="terrainLayer"
            layerTitle={t("map.terrain")}
            noDataLabel={t("map.noTerrainData")}
            url="/legends/terrain/"
            unitsLabel="m"
        />;
    }
}